/**
 * @generated SignedSource<<7fc2588f3b1d9cf33ce3361874c609f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueSummaryCell_issue$data = {
  readonly __id: string;
  readonly key: string;
  readonly " $fragmentType": "IssueSummaryCell_issue";
};
export type IssueSummaryCell_issue$key = {
  readonly " $data"?: IssueSummaryCell_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueSummaryCell_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueSummaryCell_issue",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "270f4977e8c7ece8a1fe2242c9f3d6ed";

export default node;
